/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_Practice_DescInputs */



/**
* | output |
* | --- |
* | "Practise a difficult conversation with Wundo, or talk through a situation that's on your mind." |
*
* @param {Onboarding_Value_Practice_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_practice_desc = /** @type {((inputs?: Onboarding_Value_Practice_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_Practice_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Oefen een uitdagend gesprek met Wundo, of leg een situatie voor waar je even rond wil sparren.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entraînez-vous à une conversation difficile avec Wundo, ou soumettez-lui une situation dont vous voulez discuter un moment.")
	return /** @type {LocalizedString} */ ("Practise a difficult conversation with Wundo, or talk through a situation that's on your mind.")
});